<section id="destinations" class="w-full pb-16">

  <!-- Section Heading -->
  <div class="flex flex-col items-center justify-center mt-10 mb-10 px-4">
    @if(view.isClient){
      <div class="text-center w-full max-w-4xl">
        @if (view.site?.profile?.heading) {
          @switch (view.site.profile.heading.position) {
            @case (1) {
              <app-heading_section-type01
                [options]="{
                  heading: 'Our Events',
                  title: 'Making Every Event Simply Amazing',
                  image: '',
                  description: '',
                  headingStyle: { 'text-align': 'center' },
                  swooshAlign: { 'margin': 'auto' }
                }">
              </app-heading_section-type01>
            }
            @case (2) {
              <app-heading_section-type01
                [options]="{
                  heading: 'Our Services',
                  title: 'We Provide Top-Quality Solutions for You',
                  image: 'assets/xltravel/swoosh-01.svg',
                  description: '',
                  headingStyle: { 'text-align': 'center' },
                  swooshAlign: { 'margin': 'auto' }
                }">
              </app-heading_section-type01>
            }
          }
        }
      </div>
    }
  </div>

  <!-- Optional Intro Paragraph -->
  @if(view.isClient){
    <p class="text-center text-gray-700 text-lg max-w-4xl mx-auto mb-6"
       [innerHTML]="view.page?.content.rawContent">
    </p>
  }

  <!-- Search Filter -->
  <div class="mx-4 sm:mx-8 md:mx-16 mb-8">
    <div class="bg-white p-4 rounded-lg shadow-sm">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (input)="filterEvents()"
        placeholder="Search events..."
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
    </div>
  </div>

  <!-- Event Cards -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 sm:px-8 md:px-16">
    <div *ngFor="let item of filteredPadels">
      <ng-container *ngTemplateOutlet="eventCardTemplate; context: { item: item }"></ng-container>
    </div>
  </div>

  <!-- Load More & Count -->
  <div class="flex flex-col items-center mt-10">
    @if(view.totalFilteredCount > view.visibleEventsCount) {
      <button
        (click)="loadMore()"
        class="font-semibold text-lg px-6 py-2 border-2 border-accent-500 hover:bg-primary-500 hover:border-primary-500 hover:text-white rounded-lg transition-all"
      >
        Load More
      </button>
    }
    <p class="text-sm text-gray-600 mt-4">
      {{ filteredPadels.length }} / {{ view.totalFilteredCount }} {{ view.totalFilteredCount === 1 ? 'event' : 'events' }} loaded
    </p>
  </div>

</section>

<!-- Event Card Template -->
<ng-template #eventCardTemplate let-item="item">
  <div class="bg-white rounded-lg shadow-md hover:shadow-lg overflow-hidden transition-all duration-300 flex flex-col border border-gray-100 h-full">

    <!-- Image -->
    <div class="relative aspect-[4/3] overflow-hidden">
      <img
        [src]="item.supplier.images?.rawImageUrls || 'https://p1hospitality-etbaas-production-images.s3.eu-central-1.amazonaws.com/seating-plan-categories/images/03db3cc4-9143-4fff-848c-523255438007.svg'"
        class="absolute inset-0 w-full h-full object-cover p-1"
        alt="Event image"
      />
    </div>


    <!-- Card Body -->
    <div class="p-4 flex flex-col flex-grow">
      <!-- Location -->
      <div class="flex items-center gap-2 mb-1 text-sm text-blue-600">
        <mat-icon class="text-gray-500" style="font-size: 20px;">location_on</mat-icon>
        {{ item.supplier.place }}
      </div>

      <!-- Event Title -->
      <p class="text-lg font-bold text-gray-900 line-clamp-2 mb-2">
        {{ item.supplier.name }}
      </p>

      <!-- Short Description -->
      <div class="text-sm text-gray-600 line-clamp-3 mb-4" [innerHTML]="item.supplier.contentShort"></div>

      <!-- Price & Date -->
      <div class="mt-auto pt-3 border-t border-gray-100 flex justify-between items-center text-sm text-gray-700">
        <div>
          <span class="text-xs text-gray-500 block">From</span>
          <span class="text-xl font-bold text-primary-500">
            {{ item.priceAdvertise | currency:item.currency:'symbol-narrow' }}
          </span>
        </div>
        <div class="flex items-center gap-1">
          <mat-icon style="font-size: 20px;" class="text-gray-500">event</mat-icon>
          {{ item.date | date:'mediumDate' }} • {{ item.date | date:'shortTime' }}
        </div>
      </div>
    </div>

    <!-- Card Footer -->
    <div class="bg-gray-50 border-t border-gray-100 px-4 py-3 flex justify-between items-center">
      <span class="px-3 py-1 text-xs font-semibold bg-blue-100 text-primary-800 rounded-full">
        {{ item.category }}
      </span>
      @if(view.isClient){
        <button
          mat-stroked-button
          color="primary"
          (click)="enquireEvent(item)"
          class="text-sm px-4 py-1 border-2 border-accent-500 hover:bg-primary-500 hover:text-white hover:border-primary-500 rounded-lg transition-all"
        >
          Enquire
        </button>
      }
    </div>
  </div>
</ng-template>
